import React, { useEffect } from "react";
import SpaceListItem from "./SpaceListItem";
import useGetSpaceUnreadCount from "hooks/spaceHooks/useGetSpaceUnreadCount";

interface SpaceListItemWithUnreadCountProps {
    item: any;
    index: number;
    spaceId: string;
    refreshKey: number;
}

const SpaceListItemWithUnreadCount: React.FC<SpaceListItemWithUnreadCountProps> = ({
    item,
    index,
    spaceId,
    refreshKey
}) => {
    const { unreadCount, refetch, isLoading, error } = useGetSpaceUnreadCount(item._id);

    // Refetch when refresh key changes (for manual refresh triggers)
    useEffect(() => {
        if (refreshKey > 0) {
            refetch();
        }
    }, [refreshKey, refetch]);

    // Note: Auto-read event handling is now done directly in useGetSpaceUnreadCount hook

    return (
        <SpaceListItem
            key={index}
            {...{
                id: item?._id,
                title: item?.name,
                description: item?.description,
                isStarred: item?.isPinned,
                collaborators: item?.members
                    ?.map((member: any) => {
                        const spaceMember = member as unknown as any;
                        const spaceGuest = member as unknown as any;
                        return {
                            name:
                                spaceMember?.ldb?.fullName ||
                                [
                                    spaceGuest?.guest?.firstName,
                                    spaceGuest?.guest?.lastName,
                                ]
                                    .join(" ")
                                    ?.trim(),
                            email:
                                spaceMember?.ldb?.email ||
                                spaceGuest?.guest?.email,
                            image: spaceMember?.ldb?.profile?.avatar,
                        };
                    })
                    .concat([{
                        name: "Synth",
                        email: "synth@synthally.com",
                        image: "/synth-avatar.png"
                    }]),
                numberOfCOnversations: unreadCount, // Use actual unread count
                color: item?.color || "",
                active: item?._id === spaceId,
            }}
        />
    );
};

export default SpaceListItemWithUnreadCount;
